import { motion } from 'framer-motion';
import React, { useState, useEffect, useRef } from 'react';
export default function BgTransitionLoader(props) {
    //const { navigationState } = props;
    { /*  animate={navigation.state === "loading" ? 'visible' : (clicked ? 'transitionMode' : 'hidden')}*/ }
    { /*  variants={variantTransition}*/ }
    { /*style={{*/ }
    { /*    background: "linear-gradient(to bottom left, blue, red)",*/ }
    { /*    position: "fixed", width: "100vw", height: "100vh",*/ }
    { /*    zIndex: (navigation.state === "loading" || clicked) ? '1000' : '-1'*/ }
    { /*}}*/ }
    var duration = 700; // Animation duration in milliseconds
    var containerRef = useRef(null);
    var animateFuncQueue = useRef([null, null]);
    var _a = useState(props.navigationState), navigationState = _a[0], setNavigationState = _a[1];
    var _b = useState(props.generalSettings.fields.loadingGradientColor1 || "blue"), loadingGradientColor1 = _b[0], setLoadingGradientColor1 = _b[1];
    var _c = useState(props.generalSettings.fields.loadingGradientColor2 || "red"), loadingGradientColor2 = _c[0], setLoadingGradientColor2 = _c[1];
    useEffect(function () {
        if (!!props.navigationState && props.navigationState != "loading") {
            animateNext(hide);
        }
        //console.log("BgTransitionLoader init: ", navigationState, props.navigationState);
    }, []);
    useEffect(function () {
        //console.log("BgTransitionLoader: ", navigationState, props.navigationState);
        setNavigationState(props.navigationState);
        if (props.navigationState == "loading") {
            animateNext(show);
        }
        else {
            animateNext(hide);
        }
        return function () {
        };
    }, [props.navigationState]);
    function animateNext(animateFunc) {
        //console.log("animateNext: ", animateFunc, animateFuncQueue.current);
        // add animateFunc in stack or execute next animation queue
        if (!animateFunc) {
            animateFunc = animateFuncQueue.current[1];
            animateFuncQueue.current[0] = null;
        }
        if (!animateFunc)
            return;
        if (!animateFuncQueue.current[0]) {
            animateFuncQueue.current[0] = animateFunc;
            animateFuncQueue.current[1] = null;
            animateFunc();
        }
        else {
            // add to the stack
            animateFuncQueue.current[1] = animateFunc;
        }
    }
    function show() {
        if (!containerRef.current || !containerRef.current.classList.contains('transition-hidden')) {
            animateNext(null);
            return;
        }
        containerRef.current.style.opacity = "1";
        containerRef.current.style.zIndex = "9999999";
        var startTime = 0;
        var animate = function (timestamp) {
            if (!containerRef.current)
                return;
            if (!startTime)
                startTime = timestamp;
            var progress = timestamp - startTime;
            // animate
            // FROM: linear - gradient(-45deg, rgba(0, 0, 0, 0) 100 %, rgba(0, 0, 0, 1) 180 %)
            // TO: linear-gradient(-45deg, rgba(0,0,0,0) -80%, rgba(0,0,0,1) 0%)
            //const newOpacity = Math.min(1, progress / duration);
            var newGradientProcentage1 = Math.max(-120, 100 - (progress / duration) * 220);
            var newGradientProcentage2 = Math.max(0, 220 - (progress / duration) * 220);
            //console.log("animate show: ", newGradientProcentage1, newGradientProcentage2);
            //setOpacity(newOpacity);
            //containerRef.current.style.opacity = String(newOpacity);
            // use .99 in place of 1, otherwise the browser converts rgba to rgb 
            containerRef.current.style.maskImage = containerRef.current.style.webkitMaskImage = "linear-gradient(-45deg, rgba(0,0,0,0) ".concat(newGradientProcentage1, "%, rgba(0,0,0,.99) ").concat(newGradientProcentage2, "%)");
            if (progress < duration) {
                requestAnimationFrame(animate);
            }
            else {
                if (containerRef.current.classList.contains('transition-hidden')) {
                    containerRef.current.classList.remove('transition-hidden');
                }
                animateNext(null);
            }
        };
        requestAnimationFrame(animate);
    }
    function hide() {
        if (!containerRef.current || containerRef.current.classList.contains('transition-hidden')) {
            animateNext(null);
            return;
        }
        var startTime = 0;
        var animate = function (timestamp) {
            if (!containerRef.current)
                return;
            if (!startTime)
                startTime = timestamp;
            var progress = timestamp - startTime;
            // animate
            // FROM: linear-gradient(-45deg, rgba(0,0,0,0) -80%, rgba(0,0,0,1) 0%)
            // TO:   linear - gradient(-45deg, rgba(0, 0, 0, 0) 100 %, rgba(0, 0, 0, 1) 180 %)
            //const newOpacity = Math.max(0, 1 - progress / duration);
            var newGradientProcentage1 = Math.min(100, (progress / duration) * 180 - 80);
            var newGradientProcentage2 = Math.min(180, (progress / duration) * 180);
            //setOpacity(newOpacity);
            //containerRef.current.style.opacity = String(newOpacity);
            // 45+90 = 135
            containerRef.current.style.maskImage = containerRef.current.style.webkitMaskImage = "linear-gradient(135deg, rgba(0,0,0,0) ".concat(newGradientProcentage1, "%, rgba(0,0,0,.99) ").concat(newGradientProcentage2, "%)");
            if (progress < duration) {
                requestAnimationFrame(animate);
            }
            else {
                containerRef.current.style.zIndex = "-1";
                containerRef.current.style.opacity = "0";
                if (!containerRef.current.classList.contains('transition-hidden')) {
                    containerRef.current.classList.add('transition-hidden');
                }
                animateNext(null);
            }
        };
        requestAnimationFrame(animate);
    }
    return (React.createElement(motion.div, { ref: containerRef, style: {
            background: "linear-gradient(to bottom left, ".concat(loadingGradientColor1, ", ").concat(loadingGradientColor2, ")"),
            position: "fixed",
            width: "100vw",
            height: "100vh",
            zIndex: 999999,
            maskImage: "linear-gradient(-45deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.99) 0%)",
            WebkitMaskImage: "linear-gradient(-45deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.99) 0%)",
        }, className: "loading-transition", initial: false }));
}
